import React, { useState, useEffect, useCallback } from 'react';
import { contactsAPI } from '../../../services/api';
import { Table } from '../../../components/common/Table';
import { Button } from '../../../components/common/Button';
import { Badge } from '../../../components/common/Badge';
import { Pagination } from '../../../components/common/Pagination';
import { StatCard } from '../../../components/common/StatCard';
import { PageHeader } from '../../../components/layout/PageHeader';
import { ContactForm } from './ContactForm';
import { TruckIcon } from '@heroicons/react/24/outline';
import { MagnifyingGlassIcon, PencilIcon, TrashIcon } from '@heroicons/react/24/outline';
import toast from 'react-hot-toast';

export function VendorsPage() {
  const [records,setRec]=useState([]); const [pg,setPg]=useState(null); const [loading,setL]=useState(true);
  const [search,setSrch]=useState(''); const [status,setSt]=useState(''); const [page,setPage]=useState(1);
  const [open,setOpen]=useState(false); const [editing,setEd]=useState(null);
  const [counts,setCounts]=useState({total:0,active:0,prospect:0});

  const load = useCallback(async()=>{
    setL(true);
    try {
      const r=await contactsAPI.getAll({type:'vendor',status:status||undefined,search:search||undefined,page,limit:15});
      const data=r.data||[];
      setRec(data); setPg(r.pagination);
      setCounts({total:r.pagination?.total||0,active:data.filter(x=>x.status==='active').length,prospect:data.filter(x=>x.status==='prospect').length});
    } catch { toast.error('Failed to load'); }
    finally { setL(false); }
  },[search,status,page]);

  useEffect(()=>{load();},[ load]);

  const openCreate=()=>{setEd(null);setOpen(true);};
  const openEdit=c=>{setEd(c);setOpen(true);};
  const del=async id=>{if(!window.confirm('Delete?'))return;try{await contactsAPI.delete(id);toast.success('Deleted');load();}catch{toast.error('Failed');}};

  const save=async payload=>{
    try{
      editing?await contactsAPI.update(editing._id,payload):await contactsAPI.create(payload);
      toast.success(editing?'Updated':'Added');setOpen(false);load();
    }catch(err){toast.error(err.message||'Failed');throw err;}
  };

  const cols=[
    {header:'Name',render:c=>(
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-xl bg-indigo-100 flex items-center justify-center flex-shrink-0">
          <span className="text-indigo-600 font-bold text-sm">{(c.name||'?')[0].toUpperCase()}</span>
        </div>
        <div><p className="font-semibold text-sm text-gray-900">{c.name}</p><p className="text-xs text-gray-400">{c.company||'—'}</p></div>
      </div>
    )},
    {header:'Email',  render:c=><span className="text-sm text-gray-600">{c.email||'—'}</span>},
    {header:'Phone',  render:c=><span className="text-sm text-gray-600">{c.phone||'—'}</span>},
    {header:'City',   render:c=><span className="text-sm text-gray-500">{c.address?.city||'—'}</span>},
    {header:'GSTIN',  render:c=><span className="text-xs font-mono text-gray-400">{c.gstin||'—'}</span>},
    {header:'Status', render:c=><Badge status={c.status}/>},
    {header:'',render:c=>(
      <div className="flex gap-1">
        <button onClick={()=>openEdit(c)}  className="p-1.5 hover:bg-indigo-50 rounded-lg"><PencilIcon className="w-4 h-4 text-indigo-600"/></button>
        <button onClick={()=>del(c._id)}   className="p-1.5 hover:bg-red-50 rounded-lg"><TrashIcon className="w-4 h-4 text-red-500"/></button>
      </div>
    )},
  ];

  return (
    <div className="space-y-5">
      <PageHeader title="Vendors" subtitle="Manage suppliers and vendors" actions={<Button icon={TruckIcon} onClick={openCreate}>Add Vendor</Button>}/>
      <div className="grid grid-cols-3 gap-4">
        <StatCard title="Total"     value={loading?'...':counts.total}    icon={TruckIcon} color="amber"/>
        <StatCard title="Active"    value={loading?'...':counts.active}   icon={TruckIcon} color="green"/>
        <StatCard title="Prospects" value={loading?'...':counts.prospect} icon={TruckIcon} color="blue"/>
      </div>
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
        <div className="p-4 border-b border-gray-100 flex gap-3 flex-wrap items-center justify-between">
          <div className="flex gap-3 flex-1">
            <div className="relative flex-1 min-w-44"><MagnifyingGlassIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400"/>
              <input value={search} onChange={e=>{setSrch(e.target.value);setPage(1);}} placeholder="Search vendors..." className="w-full pl-9 pr-4 py-2 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"/>
            </div>
            <select value={status} onChange={e=>{setSt(e.target.value);setPage(1);}} className="px-3 py-2 border border-gray-200 rounded-xl text-sm bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500">
              <option value="">All Status</option><option value="active">Active</option><option value="inactive">Inactive</option><option value="prospect">Prospect</option>
            </select>
          </div>
          <Button icon={TruckIcon} onClick={openCreate}>Add Vendor</Button>
        </div>
        <Table columns={cols} data={records} loading={loading} emptyMessage="No vendors found"/>
        <Pagination pagination={pg} onPageChange={setPage}/>
      </div>
      <ContactForm isOpen={open} onClose={()=>setOpen(false)} onSave={save} editing={editing} defaultType="vendor"/>
    </div>
  );
}